import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = { class: "flex flex-col self-end min-w-0 ml-2 max-w-52" };
const _hoisted_3 = { class: "text-sm font-bold truncate dark:text-gray-300" };
const _hoisted_4 = { class: "text-xs text-gray-300 dark:text-gray-500" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.workspaces.selector_item')
};
import { computed, ref } from 'vue';
import DropdownMenu from '@/components/DropdownMenu.vue';
import DropdownMenuItem from '@/components/DropdownMenuItem.vue';
import MenuDots from '@/components/MenuDots.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'SelectorItem',
    props: {
        workspace: null
    },
    emits: ['remove'],
    setup(__props) {
        const props = __props;
        const handleOpen = () => {
            opened.value = !opened.value;
        };
        const hovered = ref(false);
        const opened = ref(false);
        const joined = computed(() => !props.workspace.invitationId);
        const link = computed(() => {
            if (joined.value) {
                return { name: 'showWorkspace', params: { workspaceId: props.workspace.id } };
            }
            else {
                return {
                    name: 'joinWorkspace',
                    query: { invitationId: props.workspace.invitationId, workspaceId: props.workspace.id }
                };
            }
        });
        const avatar = computed(() => {
            return props.workspace.avatar || require('@/assets/images/default-workspace-avatar.png');
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _directive_close_popover = _resolveDirective("close-popover");
            return (_openBlock(), _createElementBlock("li", {
                class: "flex",
                onMouseenter: _cache[2] || (_cache[2] = ($event) => (hovered.value = true)),
                onMouseleave: _cache[3] || (_cache[3] = ($event) => (hovered.value = false))
            }, [
                _createVNode(_component_router_link, {
                    to: _unref(link),
                    class: "flex items-center flex-1 min-w-0 py-2 pl-6 pr-2 transition-colors hover:bg-gray-200 dark-hover:bg-wyeworks-black"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("img", {
                            "svg-inline": "",
                            src: _unref(avatar),
                            class: "w-10 h-10 rounded-md"
                        }, null, 8, _hoisted_1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.workspace.name), 1),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(joined)
                                ? _ctx.$tc('members', __props.workspace.memberCount)
                                : _ctx.$tc('members_not_joined', __props.workspace.memberCount)), 1)
                        ]),
                        (!_unref(joined) && (hovered.value || opened.value))
                            ? (_openBlock(), _createBlock(DropdownMenu, {
                                key: 0,
                                open: opened.value,
                                "onUpdate:open": _cache[1] || (_cache[1] = ($event) => ((opened).value = $event)),
                                class: "ml-auto"
                            }, {
                                item: _withCtx(() => [
                                    _createVNode(MenuDots, { onClick: handleOpen })
                                ]),
                                "menu-items": _withCtx(() => [
                                    _withDirectives(_createVNode(DropdownMenuItem, {
                                        text: _ctx.$t('reject_invitation'),
                                        icon: "remove",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('remove')))
                                    }, null, 8, ["text"]), [
                                        [_directive_close_popover]
                                    ])
                                ]),
                                _: 1
                            }, 8, ["open"]))
                            : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 1
                }, 8, ["to"])
            ], 32));
        };
    }
});
